import { useQuery as useShowSaleHubNudge } from "@faire/web-api/api/retailer/show-deals-hub-nudge/get-hooks";

import { useSettingDealsHub } from "@faire/retailer/settings/useSettingDealsHub";
import { useMilestone } from "@faire/retailer/stores/domain/useMilestone";

export const useShouldShowSaleAnnouncementTooltip = () => {
  const { hasOccurred: hasDismissedSaleAnnouncement } = useMilestone(
    "SALE_ANNOUNCEMENT_DISMISSED"
  );
  const isSaleHubUpdate = useSettingDealsHub();
  const { data, isLoading } = useShowSaleHubNudge();

  return (
    !hasDismissedSaleAnnouncement &&
    data?.should_show_nudge &&
    !isLoading &&
    isSaleHubUpdate
  );
};
